import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";

export function useUpdatePassword() {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();

  return $api.useMutation("post", "/auth/update-password", {
    onSuccess() {
      successNotification();
    },
    onError() {
      errorNotification();
    },
  });
}
